/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

/**
 * API 配置
 */
export const API_CONFIG = {
  // 基础 URL
  BASE_URL: 'https://chat.zhenyekeji.com/chatapi',
  
  // API 端点
  ENDPOINTS: {
    // 用户登录/注册
    REGISTER: '/v1/chat/register',
    // 获取会话sessionId
    GET_SESSION_ID: '/v1/chat/session/create',
    // 获取会话话题列表
    CHAT_TOPICS_LIST: '/v1/chat/user/chat_topics/list',
    // 历史消息
    HISTORY_MESSAGES: '/v1/chat/user/chat_records/list',
    // 情感预警/会话话题信息 SSE
    EMOTION_WARNINGS_SSE: '/v1/chat/user/message/sse',
    // 情绪预警列表
    EMOTION_WARNINGS_LIST: '/v1/chat/user/emotion_warmings',
    // 获取看板数据
    BOARD_DATA : '/v1/emotion_dashboard',  

  },
  
  // 请求超时时间（毫秒）
  TIMEOUT: 10000,
};

export default API_CONFIG;
